import { render, staticRenderFns } from "./ProgressReportItem.vue?vue&type=template&id=5b5ab643&"
import script from "./ProgressReportItem.vue?vue&type=script&lang=js&"
export * from "./ProgressReportItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports